import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Icons } from 'src/app/data';

@Component({
  selector: 'app-select-icon',
  templateUrl: './select-icon.component.html',
  styleUrls: ['./select-icon.component.css']
})
export class SelectIconComponent implements OnInit {

  icons = Icons;

  constructor(
    public dialogRef: MatDialogRef<SelectIconComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  onSelect(item){
    this.closeModel(item);
  }

  closeModel(item) {
    this.dialogRef.close(item);
  }

}
